import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { apiGet } from "../../api/client";
import type { OrganizationResponse } from "../../api/legacyTypes";
import { AppShell } from "../../app/AppShell";
import { CountryMark } from "../../components/CountryMark";
import { EntityLink } from "../../components/EntityLink";
import { ImageLightbox } from "../../components/ImageLightbox";
import { LocalDate } from "../../components/LocalDateTime";
import { displayPersonName } from "../../utils/personName";

export function TeamPage() {
  const { wiki = "dota2", slug = "" } = useParams();
  const query = useQuery({ queryKey: ["team", wiki, slug], queryFn: ({ signal }) => apiGet<OrganizationResponse>(`/api/v1/teams/${wiki}/${slug}`, signal) });
  if (query.isPending) return <AppShell selectedGame={wiki}><p className="state-panel">Loading team…</p></AppShell>;
  if (query.isError) return <AppShell selectedGame={wiki}><p className="state-panel state-error">Team details are not cached yet.</p></AppShell>;
  const { organization, players, tournaments, mediaUrl } = query.data;
  return (
    <AppShell selectedGame={wiki}>
      <section className="entity-hero" data-game={wiki}>
        <ImageLightbox className="entity-portrait entity-logo-large" src={mediaUrl} alt={organization.name} />
        <div><p className="eyebrow">{wiki} team</p><h1>{organization.name}</h1><div className="entity-meta"><span>{organization.location || organization.region || "Location unknown"}</span>{organization.website && <a href={organization.website}>Website ↗</a>}</div></div>
      </section>
      <section className="content-panel"><p className="eyebrow">Roster</p><h2>Players</h2><div className="entity-card-grid">{players.map((player) => <article key={player.id}><EntityLink gameId={wiki} kind="player" name={player.handle} /><small><CountryMark country={player.country} /> {player.realName ? displayPersonName(player.realName) : player.country || "Profile pending"}</small></article>)}</div></section>
      <section className="content-panel"><p className="eyebrow">History</p><h2>Tournaments</h2><div className="entity-card-grid">{tournaments.map((tournament) => <article key={tournament.id}><a href={`/tournaments/${wiki}/${tournament.id.split("/").at(-1)}`}>{tournament.name}</a><small><LocalDate value={tournament.startDate} /> · Tier {tournament.tier || "—"}</small></article>)}</div></section>
    </AppShell>
  );
}
